module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_vestland_neg.9299824d.svg";